import React, { useRef, useState, useCallback } from "react";
import { TbDownload, TbChevronDown, TbFileTypePdf, TbPresentation, TbLoader2 } from "react-icons/tb";
import { useDismissable } from "../../hooks/useDismissable";
import "./Reviews.css";

// The editor's Export menu, in the top bar so the client files are one click from any
// tab of the assessment — not tucked inside Preview, where nobody found them.
//
// Two formats, each named for what it is for, because "PDF or PPTX" is a question about
// the meeting, not about file types.
export const EXPORT_FORMATS = [
  { kind: "pdf", label: "PDF report", desc: "To email, print or file", icon: TbFileTypePdf },
  { kind: "pptx", label: "PowerPoint deck", desc: "Editable slides for the meeting", icon: TbPresentation },
];

const ExportMenu = ({ exporting, onExport }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const triggerRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDismissable(open, { ref, triggerRef, onClose: close });

  const busy = EXPORT_FORMATS.find((f) => f.kind === exporting);

  return (
    <div className="v2-export">
      {/* A plain button rather than <Button>, which does not forward a ref — and the
          dismiss logic needs the trigger to tell a toggle from an outside press. */}
      <button type="button" className="v2-btn" ref={triggerRef} data-tour="editor-export"
              aria-haspopup="menu" aria-expanded={open}
              disabled={!!exporting} onClick={() => setOpen((v) => !v)}>
        {busy ? <TbLoader2 size={15} className="v2-spin" /> : <TbDownload size={15} />}
        <span>{busy ? `Creating ${busy.kind === "pdf" ? "PDF" : "slides"}…` : "Export"}</span>
        {!busy && <TbChevronDown size={13} aria-hidden="true" />}
      </button>
      {open && (
        <div className="v2-export-menu" role="menu" ref={ref} aria-label="Export the client report">
          <div className="v2-export-head">Export the client report</div>
          {EXPORT_FORMATS.map(({ kind, label, desc, icon: Icon }) => (
            <button key={kind} type="button" role="menuitem" className="v2-export-item"
                    onClick={() => { close(); onExport(kind); }}>
              <span className={`v2-export-ic ${kind}`}><Icon size={17} /></span>
              <span className="v2-export-text">
                <span className="v2-export-label">{label}</span>
                <span className="v2-export-desc">{desc}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExportMenu;
